import axios from "axios";
import { useQuery } from "react-query";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getFranchiseeEmployees = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Report/FranchiseeEmployees`
  );
  return data;
};

export const useGetFranchiseeEmployees = () => {
  return useQuery("FranchiseeEmployees", getFranchiseeEmployees, {
    refetchOnWindowFocus: false,
  });
};
